/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Igs_Stierstadt4Inputs */

const en__field_enum_igs_stierstadt4 = /** @type {(inputs: _Field_Enum_Igs_Stierstadt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stierstadt`)
};

const de__field_enum_igs_stierstadt4 = /** @type {(inputs: _Field_Enum_Igs_Stierstadt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGS Stierstadt`)
};

/**
* | output |
* | --- |
* | "Stierstadt" |
*
* @param {_Field_Enum_Igs_Stierstadt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_igs_stierstadt4 = /** @type {((inputs?: _Field_Enum_Igs_Stierstadt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Igs_Stierstadt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_igs_stierstadt4(inputs)
	return de__field_enum_igs_stierstadt4(inputs)
});
export { _field_enum_igs_stierstadt4 as "_field_enum_IGS_Stierstadt" }